import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/TeacherVideoUploadForm.css";
import videoIcon from "../images/video_icon.svg";
import screenIcon from "../images/screen_icon.svg";
import TeacherFormInput from "./TeacherFormInput";
import TeacherTagsInput from "./TeacherTagsInput";
import uploadFileIcon from "../images/upload_file_icon.png";
import backArrow from "../images/backArrow.png";
import thumbnail_icon from "../images/thumbnail_icon.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { uploadMedia } from "../Services/AllServices";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

const TeacherVideoUploadForm = ({ onClose }) => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [isPrivate, setIsPrivate] = useState(false);
  const [file, setFile] = useState(null);
  const [thumbnail, setThumbnail] = useState(null);
  const [thumbnailPreview, setThumbnailPreview] = useState(null);
  const [isVideoMode, setIsVideoMode] = useState(true);
  const [fileName, setFileName] = useState("");
  // const [fileExtension, setFileExtension] = useState("");

  const [tagsSelected, setTagsSelected] = useState([]);

  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const thumbnailInputRef = useRef(null); // Ref for thumbnail input

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  // const handleFileChange = (event) => {
  //   const selectedFile = event.target.files[0];
  //   if (selectedFile && selectedFile.size <= 1024 * 1024 * 1024) {
  //     setFile(selectedFile);
  //     setFileName(selectedFile.name);
  //   } else {
  //     alert("File size should be less than 1GB");
  //   }
  // };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      // Immediately set the file and filename for faster feedback
      setFile(selectedFile);
      setFileName(selectedFile.name);
      // setFileExtension(selectedFile.name.split(".").pop());

      // Then handle the file size validation separately
      if (selectedFile.size > 1024 * 1024 * 1024) {
        alert("File size should be less than 1GB");
        setFile(null); // Reset file if size exceeds limit
        setFileName(""); // Clear the file name display
        // setFileExtension("");
      }
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const droppedFile = event.dataTransfer.files[0];
    if (droppedFile && droppedFile.size <= 1024 * 1024 * 1024) {
      setFile(droppedFile);
      setFileName(droppedFile.name);
      // setFileExtension("");
    } else {
      alert("File size should be less than 1GB");
    }
  };

  const handleThumbnailClick = () => {
    thumbnailInputRef.current.click(); // Trigger the file input click
  };

  const handleThumbnailChange = (event) => {
    const selectedThumbnail = event.target.files[0];
    if (selectedThumbnail) {
      setThumbnail(selectedThumbnail);
      setThumbnailPreview(URL.createObjectURL(selectedThumbnail)); // Create preview URL
    }
  };

  const handleSelectedTags = (selectedTags) => {
    try {
      const parsedTags = JSON.parse(selectedTags);
      // Only update if there's a change
      if (JSON.stringify(parsedTags) !== JSON.stringify(tagsSelected)) {
        setTagsSelected(parsedTags);
      }
    } catch (error) {
      console.error("Error parsing tags:", error);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const newTagsList = tagsSelected
      .map((tag) => tag.replace(/"/g, "").trim())
      .filter((tag) => tag); // Remove quotes and trim

    console.log("Formatted tags:", newTagsList);

    if (title && description && file && thumbnail) {
      // Prepare the formData object
      const formData = {
        title: title,
        inputfile_type: isVideoMode ? "video" : "image",
        description: description,
        tags: newTagsList, // Use the newly formatted tags here
        views: "0",
        uploader: "Teacher",
        thumbnail: thumbnail,
        video: file,
        publish: isPrivate ? "private" : "public",
      };

      // console.log("FormData: ", formData);

      try {
        const response = await uploadMedia(formData);

        // Check for response status
        if (response && response.status === "successful") {
          console.log("Upload successful:", response.message);
          navigate("/teacher/demographic-report");
        } else {
          console.error("Error uploading media:", response);
          alert(response.message || "Error uploading media. Please try again.");
        }
      } catch (error) {
        console.error("Error uploading media:", error);
        alert("There was a problem uploading the media. Please try again.");
      }

      if (onClose) {
        onClose();
      }
    } else {
      alert("Please fill in all required fields and upload a file.");
    }
  };

  const toggleMode = (isVideo) => {
    setIsVideoMode(isVideo);
  };

  return (
    <div className="uploadForm-container">
      <div className="uploadForm-left-section">
        <div className="uploadForm-left-section-header">
          <a href="/teacher" className="uploadForm_backarrow">
            <img src={backArrow} alt="back arrow" />
          </a>
          <h1>
            {isVideoMode ? "Video Upload Form" : "Presentation Upload Form"}
          </h1>
          <div className="icon-buttons">
            <div className="mode-toggle">
              <button
                onClick={() => toggleMode(true)}
                className={`toggle-button ${isVideoMode ? "active" : ""}`}
              >
                <img src={videoIcon} alt="Video Mode" />
              </button>
              <button
                disabled
                onClick={() => toggleMode(false)}
                className={`toggle-button ${!isVideoMode ? "active" : ""}`}
              >
                <img src={screenIcon} alt="Screen Mode" />
              </button>
            </div>
          </div>
        </div>
        <form onSubmit={handleSubmit}>
          <TeacherFormInput
            label={
              isVideoMode ? "Title (required)" : "Presentation Title (required)"
            }
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            rows="5"
            isRequired
          />
          <TeacherFormInput
            label={
              isVideoMode
                ? "Description (required)"
                : "Presentation Description (required)"
            }
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows="13"
          />

          <div
            className="file_upload_box"
            style={{ height: file ? "10.8vw" : "9vw" }}
          >
            <div
              className="file_upload_new"
              onDrop={handleDrop}
              onDragOver={(e) => e.preventDefault()}
            >
              <div className="upload_file_icon">
                <img src={uploadFileIcon} alt="Upload Icon" />
              </div>
              <div className="drag_drop_files">
                <div className="drag_drop_files_text">
                  Drag and drop files -OR-
                </div>
                <div className="file-size">Max size 1 GB</div>
              </div>
              <button
                type="button"
                onClick={handleButtonClick}
                className="upload-file-browse"
              >
                Browse
              </button>
              <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: "contents" }}
              />
            </div>
            <div className="selected-file">
              {/* Display selected file name */}
              {fileName && (
                <p>
                  <span className="file-name">Selected File: {fileName}</span>
                  {/* <span className="file-extension">{fileExtension}</span> */}
                </p>
              )}
            </div>
          </div>
        </form>
      </div>

      {/* Right Section */}
      <div className="upload-right-section">
        {/* Thumbnail Upload */}
        <div className="thumbnail-upload-text">
          {isVideoMode ? "Thumbnail" : "Presentation Thumbnail"}
        </div>
        <div
          className="thumbnail-upload"
          onClick={handleThumbnailClick}
          style={{
            backgroundImage: thumbnailPreview
              ? `url(${thumbnailPreview})`
              : "none",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {!thumbnailPreview && (
            <div className="thumbnail-icon">
              <img src={thumbnail_icon} alt="thumbnail icon" />
            </div>
          )}
        </div>

        <input
          type="file"
          ref={thumbnailInputRef}
          onChange={handleThumbnailChange}
          style={{ display: "none" }} // Hidden file input for thumbnail
        />

        {/* Tags Input */}
        <TeacherTagsInput onTagsChange={handleSelectedTags} />

        {/* Move the Publish Button to the Right Section */}
        <div className="upload-form-footer">
          <div className="eye-toggle">
            <FontAwesomeIcon
              icon={isPrivate ? faEyeSlash : faEye}
              onClick={() => setIsPrivate(!isPrivate)}
              className="eye-icon"
            />
            <span>{isPrivate ? "Private" : "Public"}</span>
          </div>

          {/* Submit Button */}
          <button className="upload-form-publish-button" onClick={handleSubmit}>
            Publish
          </button>
        </div>
      </div>
    </div>
  );
};

export default TeacherVideoUploadForm;
